import { useUserCountry } from 'hooks/useUserCountry'
import { useQuery } from 'react-query'
import { determineUserRegionByCountry } from 'utils/region'

export function useUserRegion() {
  const { userCountry } = useUserCountry()

  /**
   * Implemented with useQuery to cache the result.
   */
  const { data: userRegion } = useQuery({
    queryKey: ['user-region', userCountry],
    queryFn: () => {
      return determineUserRegionByCountry(userCountry)
    },
    refetchOnWindowFocus: false,
    initialData: determineUserRegionByCountry(userCountry),
    keepPreviousData: true,
  })

  return { userRegion: userRegion || null, isDetermining: !userRegion }
}
